/** Fotó mód — max felbontás, nincs aspectRatio kényszer (ne vágjon a böngésző). */

export async function openPhotoCameraStream() {
  const videoBase = {
    facingMode: { ideal: "environment" },
  };

  let stream;
  try {
    stream = await navigator.mediaDevices.getUserMedia({
      video: {
        ...videoBase,
        width: { ideal: 4032 },
        height: { ideal: 3024 },
      },
      audio: false,
    });
  } catch (_) {
    stream = await navigator.mediaDevices.getUserMedia({
      video: videoBase,
      audio: false,
    });
  }

  const track = stream.getVideoTracks()[0];
  if (track?.applyConstraints) {
    const caps = track.getCapabilities?.() || {};
    const wMax = caps.width?.max;
    const hMax = caps.height?.max;
    if (wMax && hMax) {
      try {
        await track.applyConstraints({
          width: { ideal: wMax },
          height: { ideal: hMax },
        });
      } catch (_) {
        try {
          await track.applyConstraints({ width: { ideal: wMax } });
        } catch (_) { /* ignore */ }
      }
    }
  }

  return stream;
}

/** Teljes felbontású fotó a streamből (ImageCapture ha elérhető). */
export async function capturePhotoBlob(stream, videoEl) {
  const track = stream?.getVideoTracks?.()?.[0];
  if (track && typeof window.ImageCapture !== "undefined") {
    try {
      const ic = new window.ImageCapture(track);
      if (ic.takePhoto) {
        return await ic.takePhoto({ imageWidth: track.getSettings?.().width });
      }
    } catch (_) { /* fallback */ }
  }

  const v = videoEl;
  if (!v?.videoWidth || !v?.videoHeight) throw new Error("no video");
  const w = v.videoWidth;
  const h = v.videoHeight;
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  canvas.getContext("2d").drawImage(v, 0, 0, w, h);
  return new Promise((resolve, reject) => {
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("blob"))), "image/jpeg", 0.92);
  });
}

export function videoAspectFromElement(videoEl) {
  if (!videoEl?.videoWidth || !videoEl?.videoHeight) return null;
  return videoEl.videoWidth / videoEl.videoHeight;
}
